import { usePostMutation, usePutMutation } from "@/api/swr/useMutation";
import { improvementProposalCreateSchema } from "@/schema/console/improvement-proposals/ImprovementProposalCreate";
import { z } from "zod";

type Config = Parameters<
  typeof usePutMutation<typeof improvementProposalCreateSchema, z.ZodNull>
>[3];

export const useSaveImprovementProposal = (id: string, config?: Config) => {
  return usePutMutation(
    improvementProposalCreateSchema,
    z.null(),
    `/console/improvement_proposals/${id}/save_changes`,
    config,
  );
};
